import { akEditorFullPageDefaultFontSize } from '@atlaskit/editor-shared-styles';
export var getBaseFontSize = function getBaseFontSize(appearance) {
  return appearance && appearance !== 'comment' ? akEditorFullPageDefaultFontSize : 14;
};